import React from 'react';
import { Avatar } from 'antd';
import { stringToColor } from '../util';


function AuthorAvatar({ authorName = 'Anonymous' }) {
  const authorInitial = authorName
    .charAt(0).toUpperCase();
  const backgroundColor = stringToColor(authorName);
  return (
    <Avatar alt={authorName} style={{ backgroundColor }}>
      {authorInitial}
    </Avatar>
  );
}

export default AuthorAvatar;
